import React from 'react';
import { Button, IconButton } from 'theme-ui';
import { ArrowLeftIcon, CrossIcon, MenuIcon, PlusIcon } from './icons';

// XXXIconButton: a button with just an icon
// XXXTextButton: a buttonn with just text
// XXXComboButton: a button with text and icon

export const AddComboButton = ({ onClick, ...props }: any) => (
  <Button {...props} variant="link" color="blue" onClick={onClick}>
    <PlusIcon size={24} sx={{ marginRight: 2 }} color="blue" />
    {props.children}
  </Button>
);

export const CloseIconButton = ({
  onClick,
  color = 'black',
  ...props
}: any) => (
  <IconButton onClick={onClick} {...props}>
    <CrossIcon color={color} />
  </IconButton>
);

export const ArrowLeftIconButton = ({ onClick, ...props }: any) => (
  <IconButton onClick={onClick} {...props}>
    <ArrowLeftIcon />
  </IconButton>
);

export const MenuIconButton = ({ onClick, ...props }: any) => (
  <IconButton onClick={onClick}>
    <MenuIcon color="black" />
  </IconButton>
);
